import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { useAnalyticContext } from '@/modules/analytic/providers/AnalyticProvider';
import { ANALYTICS_KEYS, Block, EventSources, Program } from '@/types';

interface TrackClickContentProps {
  block: Block;
  program: Program;
}

export const useTrackClickContent = () => {
  const { track } = useAnalyticContext();
  const { asPath } = useRouter();

  const trackClickContent = useCallback(
    ({ block, program }: TrackClickContentProps) => {
      const source = asPath.split('/')[1] || EventSources.Home;

      track(ANALYTICS_KEYS.BROWSE_CLICK_CONTENT, {
        blockUUID: block?.UUID || 'no_block_uuid',
        block_title: block?.title || 'no_block_title',
        block_type: block?.type || 'no_block_type',
        block_format: block?.format || 'no_block_format',
        programUUID: program.UUID,
        program_title: program.title,
        picture_url: program.cover,
        contentOrigin: program?.source,
        domainID: program?.domain,
        source_home: source,
      });
    },
    [asPath, track]
  );

  return { trackClickContent };
};
